<template>
  <div>
    <MapModal
      :modalNode="modalNode"
      :title="evaluationIndex.title"
      :id="evaluationIndex.id"
      :close="closeOneSelf"
    >
      <template slot="content">
        <el-form
          ref="form"
          label-position="left"
          class="settings"
          label-width="80px"
        >
          <el-form-item label="保通阶段：">
            <el-tooltip
              class="item"
              effect="dark"
              :content="stage"
              placement="right"
            >
              <!-- 17 -->
              <span class="valueStyle">{{ stage }}</span>
            </el-tooltip>
          </el-form-item>
          <el-form-item label="通行能力：">
            <span class="valueStyle">{{ ability }}</span>
          </el-form-item>
          <el-form-item label="安全性：">
            <span class="valueStyle">{{ safety }}</span>
          </el-form-item>
          <el-form-item label="工程规模：">
            <span class="valueStyle">{{ scale }}</span>
          </el-form-item>
        </el-form>
      </template>
    </MapModal>
  </div>
</template>

<script>
const MapModal = () => import("@/components/common/mapModal/Index");
import { BimSimConstructDescDetail } from "@/api/api";

export default {
  components: {
    MapModal,
  },
  data() {
    return {
      evaluationIndex: {
        title: "评价指标",
        id: "evaluationIndex",
      },
      modalNode: {
        evaluationIndex: {
          show: true, // 默认展示
          loading: false, // 加载loading
          offset: {
            // 默认弹出层偏移
            x: 55,
            left: 252,
          },
          // width: "450px", // 宽度配置 默认450px
          height: "185px", // 配置模态框中心高度
          //模态框head配置
          head: {
            //是否能拖动
            canmove: {
              //当前拖动状态
              state: true,
            },
            //折叠配置
            fold: {
              //当前折叠状态
              state: true,
            },
          },
        },
      },
      stage: "", //阶段
      ability: "", //能力
      safety: "", //安全
      scale: "", //规模
    };
  },
  methods: {
    getData() {
      console.log(this.$store.state.stageData);
      // this.$store.state.stageData.arr.forEach(el => {
      //   el.charAt(el.length-1)
      // });
      // let stage = [];
      // let ability = [];
      // let safety = [];
      // let scale = [];
      if (this.$store.state.stageData?.SimId) {
        console.log(JSON.stringify(this.$store.state.stageData.arr));
        // return;
        BimSimConstructDescDetail({
          SimId: this.$store.state.stageData.SimId,
          StageNum: parseInt(
            this.$store.state.stageData.arr.charAt(
              this.$store.state.stageData.arr.length - 1
            )
          ),
        }).then((res) => {
          this.stage = this.$store.state.stageData.arr;
          this.ability = res.data.data.passAbility;
          this.safety = res.data.data.safeNum;
          this.scale = res.data.data.projectScale;
        });
      } else {
        this.$message({
          message: "请先将时间轴拖动在阶段上！",
          type: "warning",
          duration: 1000,
        });
        this.closeOneSelf();
      }
    },
    closeOneSelf() {
      this.$emit("closeEvaluationIndex");
    },
  },
  created() {
    this.getData();
  },
  computed: {
    SimId() {
      return this.$store.state.stageData.SimId;
    },
  },
  watch: {
    SimId: {
      deep: true,
      handler: function() {
        this.getData();
      },
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
/deep/.el-form.settings {
  width: 100%;
  @include hvcenter(column);
  // padding: 8px 0 0 0;
  padding: 8px 0 14px 0;
  .el-form-item {
    width: 100%;
    padding: 0 0 0 7px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 18px;
    .el-form-item__label {
      margin-bottom: 0px;
      font-size: 12px;
      @include font_color("t_color_op1");
      padding: 0;
      flex-grow: 0;
      line-height: 32px;
      padding-right: 10px;
    }
    .el-form-item__content {
      margin-left: 0px !important;
      font-size: 12px;
      display: flex;
      align-items: center;
      flex-grow: 1;
      line-height: 32px;
      .el-select {
        @include select_base();
      }
      .el-autocomplete {
        @include select_base();
      }
      .el-input {
        @include input_base();
      }
      .el-textarea {
        @include textarea_base();
      }
      .el-checkbox {
        @include checkbox_base();
      }
    }
    .showInline {
      margin: 10px 6px;
      width: 96px;
      display: inline-block;
      text-align: right;
      @include lheight(26);
      font-size: 11px;
      @include font_color("t_color_op1");
      .el-input-number {
        margin-left: -5px !important;
        @include input_number();
      }
      .el-input-number__increase {
        height: 32px;
        line-height: 32px;
      }
      .el-input__inner {
        width: 100% !important;
      }
    }
    &:first-child {
      padding: 10px 0 0 7px;
    }
    &.description {
      margin-bottom: 12px;
    }

    &.btns {
      margin-bottom: 12px;
      .el-form-item__content {
        width: 166px;
        @include button_primary();
        @include button_default();
      }
    }
  }
}

/deep/.el-form-item {
  margin-bottom: 0px !important;
}
.valueStyle {
  color: rgba(255, 255, 255, 0.9);
}
</style>
